export default __webpack_public_path__ + "static/media/dashboard.2fed9d24.svg";